import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../Layout";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Tick from "../animations/Tick";

export default function PreContract() {
    const [data, setData] = useState({});
    const [dbId, setDbId] = useState("");
    const [issue, setIssue] = useState(false);
    const navigate = useNavigate();
    const [problem, setProblem] = useState("");
    const [userName, setUserName] = useState("");
    const [tick, setTick] = useState(false);
    const [errorAlert, setErrorAlert] = useState(false);
    // const url="http://10.0.0.174:4030"
    const url = process.env.REACT_APP_HR_API_URL;
    const [noDetails, setNoDetails] = useState(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const userId = queryParams.get("id");
        const token = queryParams.get("token");
        if (token) sessionStorage.setItem("onboardingToken", token);
        setDbId(userId);
        const headers = sessionStorage.getItem("onboardingToken") ? { "x-onboarding-token": sessionStorage.getItem("onboardingToken") } : {};
        let hourly, middleName;
        axios
            .get(`${url}/onBoard/new-start/${userId}`, { headers })
            .then((res) => {
                if (res.data._id) {
                    setData(res.data);
                } else {
                    if (res.data.salaryHourly) {
                        hourly = res.data.salaryHourly;
                    } else if (res.data.salaryYearly) {
                        hourly = res.data.salaryYearly;
                    }
                    middleName = res.data.middleName == null ? "" : res.data.middleName;
                    setData({
                        title: res.data.title,
                        firstName: res.data.firstName,
                        middleName: middleName,
                        lastName: res.data.lastName,
                        startDate: res.data.startDate,
                        contract: res.data.contractedHours,
                        signedContract: res.data.signedContract,
                        hourly: hourly,
                        company: res.data.companyName,
                        position: res.data.position,
                    });
                    setUserName(res.data.email);
                }
            })
            .catch(() => {
                setNoDetails(true);
            });
    }, [url]);
    const handleSign = () => {
        const headers = sessionStorage.getItem("onboardingToken") ? { "x-onboarding-token": sessionStorage.getItem("onboardingToken") } : {};
        axios
            .get(`${url}/onBoard/new-start/${dbId}/contractRead`, { headers })
            .then((res) => {
                navigate(`/contract?id=${dbId}`);
            })
            .catch(() => {});
    };

    const handleSendHr = () => {
        const data = {
            id: dbId,
            issue: problem,
            email: userName,
        };
        const token = sessionStorage.getItem("onboardingToken");
        const headers = token ? { "x-onboarding-token": token } : {};
        axios
            .post(`${url}/onBoard/new-start/help`, data, { headers })
            .then((res) => {
                // console.log(res.data);
                setIssue(false);
                setTick(true);
                setTimeout(() => {
                    setTick(false);
                    navigate("/wrong-details");
                }, 3000);
            })
            .catch((err) => {
                setErrorAlert(true);
                setTimeout(() => {
                    setErrorAlert(false);
                }, 3000);
            });
    };

    const isSalaried =
        data.position?.includes("Manager") ||
        data.position === "Area Manager" ||
        data.company === "Head Office" ||
        (data.company === "Nitro Solutions 23 Ltd" &&
            data.position !== "Warehouse Assistant" &&
            data.position !== "Warehouse Packer");

    return (
        <Layout>
            <Container maxWidth="sm" sx={{ py: { xs: 3, sm: 5 }, textAlign: "center" }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Step 1 of 2 — Confirm your details
                </Typography>

                {!noDetails ? (
                    <>
                        <Typography variant="h5" sx={{ mb: 2 }}>
                            <Box component="span" color="error.main" sx={{ fontWeight: 700 }}>
                                {data.firstName}
                            </Box>{" "}
                            Welcome to your contract
                        </Typography>

                        {errorAlert ? (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                Something went wrong, please try again
                            </Alert>
                        ) : (
                            <></>
                        )}
                        {data.signedContract === false ? (
                            <>
                                <Typography variant="h6" sx={{ mb: 2 }}>
                                    You are about to sign your contract, please
                                    check these details before continuing.
                                </Typography>
                                <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 }, mb: 3, textAlign: "left" }}>
                                    <Stack spacing={1.5}>
                                        <Typography variant="body1">
                                            <strong>Full Name:</strong>{" "}
                                            <Box component="span" color="error.main">
                                                {data.title} {data.firstName}{" "}
                                                {data.middleName} {data.lastName}
                                            </Box>
                                        </Typography>
                                        <Typography variant="body1">
                                            <strong>Start Date:</strong>{" "}
                                            <Box component="span" color="error.main">
                                                {new Date(
                                                    data.startDate
                                                ).toLocaleDateString("en-GB")}
                                            </Box>
                                        </Typography>
                                        <Typography variant="body1">
                                            <strong>Contract:</strong>{" "}
                                            <Box component="span" color="error.main">
                                                {data.contract}
                                            </Box>
                                        </Typography>
                                        <Typography variant="body1">
                                            <strong>{isSalaried ? "Salary:" : "Hourly Rate:"}</strong>{" "}
                                            <Box component="span" color="error.main">
                                                {data.hourly}
                                            </Box>
                                        </Typography>
                                    </Stack>
                                </Paper>
                                <Stack
                                    direction={{ xs: "column", sm: "row" }}
                                    spacing={2}
                                    justifyContent="center"
                                    sx={{ width: "100%" }}
                                >
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={() => handleSign()}
                                        sx={{ flex: { sm: "0 1 auto" } }}
                                    >
                                        View &amp; Sign
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={() => {
                                            setIssue(!issue);
                                        }}
                                        sx={{ flex: { sm: "0 1 auto" } }}
                                    >
                                        Wrong Details
                                    </Button>
                                </Stack>
                                {issue ? (
                                    <Stack spacing={2} sx={{ mt: 3, textAlign: "left" }}>
                                        <Typography variant="body2">
                                            Let us know what is your issue:
                                        </Typography>
                                        <TextField
                                            multiline
                                            rows={5}
                                            placeholder="Your issue..."
                                            onChange={(e) =>
                                                setProblem(e.target.value)
                                            }
                                        />
                                        <Button
                                            variant="outlined"
                                            onClick={() => handleSendHr()}
                                        >
                                            Send to HR
                                        </Button>
                                    </Stack>
                                ) : (
                                    <></>
                                )}
                                {tick ? <Tick /> : <></>}
                            </>
                        ) : (
                            <Typography variant="h6">
                                Your contract has been signed, if you have
                                not received it in the next hour please
                                contact HR on:{" "}
                                <Box
                                    component="a"
                                    href="tel:01415301655"
                                    color="error.main"
                                >
                                    0141 530 1655
                                </Box>{" "}
                                or{" "}
                                <Box
                                    component="a"
                                    href="mailto:team@jedihrsolutions.co.uk"
                                    color="error.main"
                                >
                                    team@jedihrsolutions.co.uk
                                </Box>
                            </Typography>
                        )}
                    </>
                ) : (
                    <Typography variant="h6">
                        Details have not been found please contact HR on:{" "}
                        <Box component="a" href="tel:01415301655" color="error.main">
                            0141 530 1655
                        </Box>{" "}
                        or{" "}
                        <Box
                            component="a"
                            href="mailto:team@jedihrsolutions.co.uk"
                            color="error.main"
                        >
                            team@jedihrsolutions.co.uk
                        </Box>
                    </Typography>
                )}
            </Container>
        </Layout>
    );
}
